import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';

import logger from 'logger';
import ApiService from 'services/ApiService/ApiService';

import { JSON_URL } from './Api';


const ACCEPT_ALL_REQUESTS = 'cam4/user/ACCEPT_ALL_REQUESTS';
const ACCEPT_REQUEST = 'cam4/user/ACCEPT_REQUEST';
const DELETE_ALL_REQUEST = 'cam4/user/DELETE_ALL_REQUEST';
const DELETE_REQUEST = 'cam4/user/DELETE_REQUEST';
const UPDATE_FRIENDS = 'cam4/user/UPDATE_FRIENDS';

export const NAME = 'friends';

const initialState = Immutable.fromJS({
  notifications: '',
  friends: [],
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FRIENDS:
      return state.set('friends', Immutable.fromJS(action.friends));

    case ACCEPT_REQUEST:
      return state.set(
        'friends',
        state.get('friends').filter((friend) => friend.get('username') !== action.friend.get('username'))
      );

    case DELETE_REQUEST:
      return state.set(
        'friends',
        state.get('friends').filter((friend) => friend.get('username') !== action.friend.get('username'))
      );

    case ACCEPT_ALL_REQUESTS:
      return state.set('friends', initialState.get('friends'));

    case DELETE_ALL_REQUEST:
      return state.set('friends', initialState.get('friends'));

    default:
      return state;
  }
}

const friends = (state) => state[NAME].get('friends').toArray();

function updateFriends(friends) {
  return {
    type: UPDATE_FRIENDS,
    friends,
  };
}

function getFriends() {
  return (dispatch) =>
    ApiService.get(JSON_URL)
      .then(
        (res) => dispatch(updateFriends(res.data)),
        (error) => logger.warn(error));
}

function acceptRequest(friend) {
  return {
    type: ACCEPT_REQUEST,
    friend,
  };
}

function deleteRequest(friend) {
  return {
    type: DELETE_REQUEST,
    friend,
  };
}

function deleteAllRequests(friends) {
  return {
    type: DELETE_ALL_REQUEST,
    friends,
  };
}

function acceptAllRequests(friends) {
  return {
    type: ACCEPT_ALL_REQUESTS,
    friends,
  };
}

export const selector = createStructuredSelector({ friends });

export const actionCreators = {
  getFriends,
  acceptRequest,
  deleteRequest,
  deleteAllRequests,
  acceptAllRequests,
};
